module.exports = __webpack_public_path__ + "img/rocket.ffbdf466.svg";